<template>
  <v-app>
    <v-alert
      v-if="errorMessage"
      class="ma-0 error-alert"
      dismissible
      type="error"
      style="z-index: 1000"
      @input="hideError"
    >
      {{ errorMessage }}
    </v-alert>
    <v-alert
      v-if="successMessage"
      class="ma-0 error-alert"
      type="success"
      style="z-index: 1000"
      :dismissible="successDismissible"
      @input="hideSuccess"
    >
      {{ successMessage }}
    </v-alert>

    <router-view class="fill-height" />
  </v-app>
</template>

<script>
import pjson from "../package.json";
import { HIDE_ERROR, ERROR, HIDE_SUCCESS, SUCCESS } from "./store/actions/ui";

export default {
  name: "App",
  computed: {
    errorMessage() {
      return this.$store.getters.error;
    },
    successMessage() {
      return this.$store.getters.success;
    },
    successDismissible() {
      return this.$store.getters.successDismissible;
    },
  },
  methods: {
    hideError() {
      this.$store.dispatch(HIDE_ERROR);
    },
    showError(error) {
      this.$store.dispatch(ERROR, error);
    },
    hideSuccess() {
      this.$store.dispatch(HIDE_SUCCESS);
    },
    showSuccess(success) {
      this.$store.dispatch(SUCCESS, success);
    },
  },
  created() {
    console.log(`v${pjson.version}`);
    document.addEventListener("error", ({ detail }) => {
      this.showError(detail.message);
    });
    document.addEventListener("success", ({ detail }) => {
      this.showSuccess(detail.message);
    });
  },
};
</script>

<style lang="scss">
@import "./styles/main.scss";
.error-alert {
  font-family: MainFont;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 0 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

main,
.main-bg {
  background: #fafafa;
}

.highlight:hover {
  background-color: #fafafa;
}

.container {
  padding: 16px 32px !important;
}
</style>
